export const projects = {
  avoidableAddress: ["none", "unknown"]
};

export const userDefinedParcelsCityName = "User Defined Parcels";
